import React from 'react';
import { Link } from 'react-router-dom';
import { SmoothHouseIcon } from '@components/icons/smooth-house-icon';
import {
  HeaderContainer,
  HeaderLink,
  HeaderContent,
  LogoIcon,
  LogoText,
} from './header.styles';

export const Header: React.FC = () => (
  <HeaderContainer>
    <HeaderLink as={Link} to="/" aria-label="The Home CEO — home">
      <HeaderContent>
        <LogoIcon>
          <SmoothHouseIcon />
        </LogoIcon>
        <LogoText>The Home CEO</LogoText>
      </HeaderContent>
    </HeaderLink>
  </HeaderContainer>
);
